import { useCallback, useEffect } from 'react';
import { useSdkQuery } from '@/provider';
import { sub } from 'date-fns/sub';
import { startOfDay } from 'date-fns/startOfDay';
import { endOfDay } from 'date-fns/endOfDay';
import { Stats, DashboardController } from '../types';

export type DashboardControllerProps = {
  filter?: {
    from: Date;
    to: Date;
  };
  onLoad?: (data: Stats) => void;
  onRefresh?: () => void;
  onRequest?: () => void;
};

const DEFAULT_FILTER = {
  from: sub(startOfDay(new Date()), { months: 1 }),
  to: endOfDay(new Date()),
};

export function useDashboardController(
  props: DashboardControllerProps
): DashboardController {
  const {
    filter = DEFAULT_FILTER,
    onLoad = () => {},
    onRefresh = () => {},
    onRequest = () => {},
  } = props;

  const dashboard = useSdkQuery(
    `dashboard-${JSON.stringify(filter)}`,
    async (sdk) => {
      return sdk.dashboard.getByDate(filter.from, filter.to);
    },
    {
      keepPreviousData: true,
      onSuccess: (response) => {
        onLoad(response);
      },
    }
  );

  const refresh = useCallback(() => {
    onRefresh();

    void dashboard.reload();
  }, [dashboard, onRefresh]);

  useEffect(() => {
    onRequest();
  }, []); // eslint-disable-line

  return { data: dashboard.data, loading: dashboard.loading, refresh };
}
